export interface CookieResourceLocation {
  name: string;
}
